export enum DelegationsQueryParamKey {
  VEHICLE_UUID = 'vehicleUuid',
  TRAILER_UUID = 'trailerUuid',
  PRIMARY_DRIVER_UUID = 'primaryDriverUuid',
  SECONDARY_DRIVER_UUID = 'secondaryDriverUuid',
}
